/**
 * @generated SignedSource<<7faa68870ec87b1b3566c69330abeefe>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRefreshMetadata_nftItem$data = {
  readonly serviceId: string | null;
  readonly " $fragmentType": "useRefreshMetadata_nftItem";
};
export type useRefreshMetadata_nftItem$key = {
  readonly " $data"?: useRefreshMetadata_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRefreshMetadata_nftItem">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useRefreshMetadata_nftItem",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};

(node as any).hash = "269ce7771a195e4d2ae32398c5294a7d";

export default node;
